import dayjs, { Dayjs } from "dayjs"
import { IReviewPeriod } from "./reviewPeriod.types"
import { ReviewReasonOptions } from "./reviewPeriodHelper"

export class ReviewPeriod implements IReviewPeriod {
  id: number
  createdBy: string
  createdDttm: Dayjs
  fromDttm: Dayjs
  reason: string
  isPropertySuppressed: boolean
  isBillingSuppressed: boolean
  isDunningSuppressed: boolean
  isPaymentCollectionSuppressed: boolean
  isPaymentReviewSuppressed: boolean
  description?: string
  toDttm?: Dayjs
  cancelledDttm?: Dayjs
  cancelledBy?: string

  constructor(
    id: number,
    createdBy: string,
    createdDttm: Dayjs,
    fromDttm: Dayjs,
    reason: string,
    isPropertySuppressed: boolean,
    isBillingSuppressed: boolean,
    isDunningSuppressed: boolean,
    isPaymentCollectionSuppressed: boolean,
    isPaymentReviewSuppressed: boolean,
    description?: string,
    toDttm?: Dayjs,
    cancelledDttm?: Dayjs,
    cancelledBy?: string,
  ) {
    this.id = id
    this.createdBy = createdBy
    this.createdDttm = createdDttm
    this.fromDttm = fromDttm
    this.reason = reason
    this.isPropertySuppressed = isPropertySuppressed
    this.isBillingSuppressed = isBillingSuppressed
    this.isDunningSuppressed = isDunningSuppressed
    this.isPaymentCollectionSuppressed = isPaymentCollectionSuppressed
    this.isPaymentReviewSuppressed = isPaymentReviewSuppressed
    this.description = description
    this.toDttm = toDttm
    this.cancelledDttm = cancelledDttm
    this.cancelledBy = cancelledBy
  }

  get isActive(): boolean {
    if (this.isCancelled) return false
    if (this.isExpired) return false
    return true
  }

  get isExpired(): boolean {
    if (this.isCancelled) return false
    if (!this.toDttm) return false
    const now = dayjs()
    return this.toDttm.isBefore(now)
  }

  get isCancelled(): boolean {
    return !!this.cancelledDttm
  }

  get isDeceased(): boolean {
    return (
      this.reason.includes(ReviewReasonOptions.COTDeceased) ||
      this.reason.includes(ReviewReasonOptions.CustomerDeceased)
    )
  }
}
